export default __webpack_public_path__ + "static/media/favicon.c59b1ffc.png";